import {
  WIDGET_MATCHES_CACHE,
  WIDGET_MATCHES_SUCCESS,
  PROFILE_REQUEST,
  PROFILE_FAIL,
  WIDGET_MATCHES_REQUEST,
  ROUTE_CHANGE,
  WIDGET_MATCHES_FAIL,
} from 'actionTypes';

const initialItemState = {
  uid: null,
};

const itemReducer = (state = initialItemState, action) => {
  switch (action.type) {
    case WIDGET_MATCHES_CACHE:
    case WIDGET_MATCHES_SUCCESS:
      return {
        ...state,
        uid: action.payload.uid,
      };
    default:
      return state;
  }
};

const initialState = {
  uid: null,
  loading: false,
  flash: null,
  count: 0,
  results_id: '',
  items: [],
};

export default widgetName => (state = initialState, action) => {
  switch (action.type) {
    case PROFILE_REQUEST:
      return {
        ...initialState,
        uid: action.payload.uid,
      };
    case PROFILE_FAIL:
      return initialState;
    case WIDGET_MATCHES_REQUEST: {
      const { widget } = action.payload;
      if (widget !== widgetName) {
        return state;
      }
      return {
        ...state,
        loading: true,
        flash: null,
      };
    }
    case ROUTE_CHANGE: {
      return {
        ...initialState,
      };
    }
    case WIDGET_MATCHES_CACHE:
    case WIDGET_MATCHES_SUCCESS: {
      const { widget } = action.payload;
      if (widget !== widgetName) {
        return state;
      }
      return {
        ...state,
        items: action.payload.profiles.map(profile => itemReducer(undefined, { ...action, payload: profile })),
        count: action.payload.meta.max,
        results_id: action.payload.meta.results_id,
        loading: false,
        flash: null,
      };
    }
    case WIDGET_MATCHES_FAIL: {
      const { widget } = action.payload;
      if (widget !== widgetName) {
        return state;
      }
      return {
        ...state,
        loading: false,
        flash: action.payload.error.message,
      };
    }
    default:
      return state;
  }
};
